import React from "react";
import { Portal, Icon } from "@app/components";
import {
  Container,
  Backdrop,
  DialogContainer,
  CloseIcon,
  Body,
  Footer,
  Header,
  Title,
  DialogContent,
} from "./dialog-components";

type Props = {
  children?: React.ReactNode;
  onClose?: (e: any) => void;
  title?: string;
  className?: string;
  noTitle?: boolean
};

export default function Dialog({ title, noTitle, children, className, onClose }: Props) {
  return (
    <Portal>
      <Container>
        <Backdrop />
        <DialogContainer>
          {!noTitle && (
            <Header>
              {title && <Title>{title}</Title>}
              <CloseIcon onClick={onClose}>
                <Icon name="close" />
              </CloseIcon>
            </Header>
          )}
          {noTitle && (
            <CloseIcon onClick={onClose} className="self-positioned">
              <Icon name="close" />
            </CloseIcon>
          )}
          <DialogContent className={className}>
            {children}
          </DialogContent>
        </DialogContainer>
      </Container>
    </Portal>
  );
}

Dialog.Body = Body;
Dialog.Footer = Footer;
